import React, { useEffect, useRef } from 'react';
import readConfig from "../utils/readClientConfiguration";
import appConfiguration from "../config/default.json";

const CookieDeclaration = () => {
    const cookieBotDomainGroupId = readConfig(appConfiguration, 'cookieBotDomainGroupId');
    const containerRef = useRef(null); // 👈 miejsce docelowe skryptu

    useEffect(() => {
        if (!cookieBotDomainGroupId || !containerRef.current) return;

        const existingScript = document.getElementById('CookieDeclaration');
        if (existingScript) return;

        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = `https://consent.cookiebot.eu/${cookieBotDomainGroupId}/cd.js`;
        script.type = 'text/javascript';
        script.async = true;

        containerRef.current.appendChild(script); // 👈 zamiast document.body
    }, [cookieBotDomainGroupId]);

    return <div ref={containerRef} />; // 👈 kontener na skrypt
};

export default CookieDeclaration;

